import qs from 'qs'
// import { Toast } from 'vant'
import crypto from '../utils/cryptojs.js'
import md5 from 'js-md5'
import * as tokenUtils from '@/utils/TokenUtils'
const { SFApi } = window
const isInClient = SFApi ? SFApi.isInClient() : false
let h5Secret = process.env.VUE_APP_ENCRYPT_SECRET
let h5ParamSecret = process.env.VUE_APP_ENCRYPT_PARAM_SECRET

// if (process.env.VUE_APP_MODE == 'production') {
//   // 生产
//   h5Secret = '49cc525ac264fa6f755351'
//   h5ParamSecret = 'c95ca918a19366480cd0f40cd50784a0'
// } else {
//   // 测试
//   h5Secret = '07bb1ada1425d9f137aa65'
//   h5ParamSecret = 'aeef329f599e41f7de918d618f0f970a'
// }
// check是否是对象
// function checkJSON(obj) {
//   let ret = false
//   if (obj && obj instanceof Object) {
//     for (const key in obj) {
//       if (obj.hasOwnProperty(key)) {
//         if (obj[key] instanceof Object || obj[key] instanceof Array) {
//           ret = true
//         }
//       }
//     }
//   }
//   return ret
// }
// js创建含数字字母的随机字符串
function generateRdStr(len) {
  len = len || 32
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < len; i++) text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}
// const applicationJSON = 'application/json;charset=utf-8'
const timestamp = parseInt(new Date().getTime() / 1000).toString()

const setInterceptors = (axiosInstance) => {
  // 请求拦截
  axiosInstance.interceptors.request.use(
    (config) => {
      if ((config.noEncrypt && config.noEncrypt == true) || process.env.VUE_APP_ENCRYPT == 'false') {
        //不加密
      } else {
        config.headers['X-Terminal'] = 'Wap'
        config.headers['X-Timestamp'] = timestamp
        config.headers['X-Nonce'] = new Date().getTime().toString() + generateRdStr(8)
        //请求加密
        if (config.method == 'get') {
          if (config.params) {
            var query = config.params
            config.params = { query: crypto.sm4encrypt(qs.stringify(query), timestamp + h5Secret) }
          } else {
            config.params = {}
          }
        } else {
          if (config.data) {
            var data = config.data
            config.data = { body: crypto.sm4encrypt(JSON.stringify(data), timestamp + h5Secret) }
          } else {
            // config.data = { body: '' }
          }
        }
        //验签
        if (config.method == 'get') {
          let param = {}
          param.body = config.params.query
          param.method = 'GET'
          param.nonce = config.headers['X-Nonce']
          param.secretkey = h5ParamSecret + config.headers['X-Nonce']
          param.timestamp = config.headers['X-Timestamp']
          if (config.url.startsWith('/api/creditmall')) {
            param.uri = config.url.replace(process.env.VUE_APP_PHP_BASE_API, '')
          } else {
            param.uri = config.url.replace(process.env.VUE_APP_XINGJIAN_API, '')
          }
          config.headers['X-Signature'] = md5(qs.stringify(param))
        } else {
          let param = {}
          config.data && (param.body = config.data.body)
          param.method = config.method.toUpperCase()
          param.nonce = config.headers['X-Nonce']
          param.secretkey = h5ParamSecret + config.headers['X-Nonce']
          param.timestamp = config.headers['X-Timestamp']
          if (config.url.startsWith('/api/creditmall')) {
            param.uri = config.url.replace(process.env.VUE_APP_PHP_BASE_API, '')
          } else {
            param.uri = config.url.replace(process.env.VUE_APP_XINGJIAN_API, '')
          }
          config.headers['X-Signature'] = md5(qs.stringify(param))
        }
      }
      if (tokenUtils.getToken()) {
        // if (config.type === "form") {
        //   config.headers["Content-Type"] === "application/x-www-form-urlencoded"
        // } else if (config.type == "upload") {
        //   console.log("进入")
        //   config.headers["Content-Type"] = "multipart/form-data"
        // } else if (checkJSON(config.data) || config.type === "json") {
        //   config.headers["Content-Type"] = applicationJSON
        // }
        config.headers['X-Authorization'] = `Bearer ${tokenUtils.getToken()}`

        // if (
        //   config.headers["Content-Type"] === "application/x-www-form-urlencoded"
        // ) {
        //   config.data = qs.stringify(config.data)
        // }
        // if (
        //   config.headers["Content-Type"] === "application/json"
        // ) {
        //   config.data = JSON.stringify(config.data)
        // }
      }
      // 走授权的接口使用授权专用的token
      if (tokenUtils.getAppToken() && config.url.indexOf('self-apps/api') != -1) {
        config.headers['X-Authorization'] = `Bearer ${tokenUtils.getAppToken()}`
      }
      if ((config.noEncrypt && config.noEncrypt == true) || process.env.VUE_APP_ENCRYPT == 'false') {
        config.headers['x-debug-token'] = process.env.VUE_APP_ENCRYPT_TOKEN
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  // 响应拦截
  axiosInstance.interceptors.response.use(
    (res) => {
      // console.log(res, '响应体')
      //这里是解密
      if (res.data && res.data?.code != undefined) {
        //不解密
        if (res.data.code == 40003) {
          console.log(res.data.message, 'token过期')
          sessionStorage.clear()
          if (isInClient) {
            SFApi.user.logout(function (code) {
              if (code == 1) {
                window.location.reload()
              } else {
                SFApi.back()
              }
            })
          }
        }
        if ((res.data.code && res.data.code != 0 && res.data.code != 200 && res.data.code != 201) || (res.data.error_code && res.data.error_code != 10000) || (res.data.ErrorCode && res.data.ErrorCode != 10000)) {
          console.log(res.data.msg || res.data.error_msg || res.data.message)
          return Promise.reject(res.data?.message || res.data?.msg)
        }
        return res.data
      } else {
        res.data.body = crypto.sm4decrypt(res.data.body, timestamp + h5Secret)
        const data = JSON.parse(res.data.body)
        if (data.code == 40003) {
          sessionStorage.clear()
          if (isInClient) {
            SFApi.user.logout(function (code) {
              if (code == 1) {
                window.location.reload()
              } else {
                SFApi.back()
              }
            })
          }
        }

        if ((data.code && data.code != 0 && data.code != 200 && data.code != 201) || (data.error_code && data.error_code != 10000) || (data.ErrorCode && data.ErrorCode != 10000)) {
          console.log(data.msg || data.error_msg || data.message)
          return Promise.reject(data?.message || data.msg)
        }
        res.data = data
        return res.data
      }
    },
    (error) => {
      console.log(error, 'error')
      return Promise.reject(error.response)
    }
  )
}
export default setInterceptors
